import React from 'react';
import { DownloadFile } from '../../lib/utils';
import Notifications from '../../lib/notifications';
import { fileExtension } from '../../constants/file';
import Localization from '../../config/localization';
import { isFunction } from 'lodash';

class FileDownload<T> extends React.Component<FileDownload.IProps<T>, FileDownload.IState> {
  _getTemplateFile = async (event: React.MouseEvent<HTMLAnchorElement>) => {
    const { fileName = Localization.fileImportTemplateName, apiCall, extension = fileExtension } = this.props;

    try {
      event.preventDefault();

      await this.setState({ loading: true });

      const response = await apiCall();

      await DownloadFile(response.data, `${fileName}.${extension}`, { type: response.headers['content-type'] });
      return this.setState({ loading: false });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  render() {
    const { children } = this.props;

    return <div>
      {isFunction(children) ? children({ onClick: this._getTemplateFile }) : children}
    </div>;
  }
}

export default FileDownload;